import React, { useState, useCallback, useEffect } from 'react';
import { Chart, Series, Legend, ValueAxis, Tooltip,
  AggregationInterval, ArgumentAxis,
  TickInterval, CommonSeriesSettings, } from 'devextreme-react/chart';
import PieChart, {
  Legend as PCLegend,
  Series as PCSeries,
  Tooltip as PCTooltip,
  Label,
  Connector,
} from 'devextreme-react/pie-chart';
import { groupBy } from '../../utils/miscUtil';

const palette = ["rgba(20, 77, 109, 1)", "rgba(236, 80, 32, 1)", "rgba(92, 194, 215, 1)", "rgba(0, 162, 200, 1)", "rgba(20, 77, 109, 0.4)", "rgba(236, 80, 32, 0.4)", "rgba(92, 194, 215, 0.4)", "rgba(0, 162, 200, 0.4)"]

export default function HSESafetyStrategy(props) {
  const [collectionDataEmpl, setCollectionDataEmpl] = useState([]);
  const [collectionDataCont, setCollectionDataCont] = useState([]);
  const [procSafetyData, setProcSafetyData] = useState([]);
  const [obsSafetyData, setObsSafetyData] = useState([]);

  useEffect(() => {
    var fd = props.data.filter((e) => {return e["year"]===props.year});
    var fd1 = fd.filter((e) => {return e["Identifier"]==="7"});
    for (i=0; i<fd1.length; i++){
      if (!fd1[i]["value"]) {
        fd1[i]["value"] = "NR"
      }
    }
    fd1 = groupBy(fd1,"value");
    fd1 = Object.keys(fd1).map((key) => ({name: key, val: fd1[key].length}));
    setCollectionDataEmpl(fd1);

    fd1 = fd.filter((e) => {return e["Identifier"]==="23"});
    for (i=0; i<fd1.length; i++){
      if (!fd1[i]["value"]) {
        fd1[i]["value"] = "NR"
      }
    }
    fd1 = groupBy(fd1,"value");
    fd1 = Object.keys(fd1).map((key) => ({name: key, val: fd1[key].length}));
    setCollectionDataCont(fd1);

    fd = props.data.filter((e) => {return e["Identifier"]==="43"});
    fd1={}
    for (var i=0; i<fd.length; i++) {
      fd1[new Date(fd[i]['year'], 0)]={date: new Date(fd[i]['year'], 0), ycnt:0, ncnt:0, nrcnt:0}
    }
    for (i=0; i<fd.length; i++) {
      if (fd[i].value === "Yes") {
        fd1[new Date(fd[i]['year'], 0)].ycnt++;
        continue;
      }
      if (fd[i].value === "No") {
        fd1[new Date(fd[i]['year'], 0)].ncnt++;
        continue;
      }
      fd1[new Date(fd[i]['year'], 0)].nrcnt++;
    }
    fd1 = Object.keys(fd1).map((key) => (fd1[key]))
    setProcSafetyData(fd1);

    fd = props.data.filter((e) => {return e["Identifier"]==="46"});
    fd1={}
    for (i=0; i<fd.length; i++) {
      fd1[new Date(fd[i]['year'], 0)]={date: new Date(fd[i]['year'], 0), ycnt:0, ncnt:0, nrcnt:0}
    }
    for (i=0; i<fd.length; i++) {
      if (fd[i].value === "Yes") {
        fd1[new Date(fd[i]['year'], 0)].ycnt++;
        continue;
      }
      if (fd[i].value === "No") {
        fd1[new Date(fd[i]['year'], 0)].ncnt++;
        continue;
      }
      fd1[new Date(fd[i]['year'], 0)].nrcnt++;
    }
    fd1 = Object.keys(fd1).map((key) => (fd1[key]))
    setObsSafetyData(fd1);

  }, [props.data, props.year]);

  const customizeTooltip = useCallback((pointInfo) => {
    var txt = ''
    txt = `<div><div class="tooltip-header">${pointInfo.argumentText}: ${pointInfo.valueText}</div></div>`
    return {
      html: txt,
    }
  }, []);

  return (
    <>
    <h4>Safety Strategy (Qualitative Metrics)</h4>
    <hr className={'mb-2'}/>
    <div className="d-flex flex-row justify-content-between">

      <div className="d-flex flex-column justify-content-between" style={{width:"50%"}}>
        <Chart
          id="chart"
          dataSource={procSafetyData}
          title='Does your company track process safety events?'
          rotated={true}
        >
          <ArgumentAxis aggregatedPointsPosition="crossTicks">
            <AggregationInterval years={1} />
            <TickInterval years={1} />
          </ArgumentAxis>
          <CommonSeriesSettings
            argumentField="date"
          >
          </CommonSeriesSettings>
          <Series
            type="stackedbar"
            valueField="ycnt"
            name="Yes"
            color="rgba(20, 77, 109, 0.8)"
          >
          </Series>
          <Series
            type="stackedbar"
            valueField="ncnt"
            name="No"
            color="rgba(236, 80, 32, 0.8)"
          >
          </Series>
          <Series
            type="stackedbar"
            valueField="nrcnt"
            name="NR"
            color="rgba(0, 0, 0, 0.1)"
          >
          </Series>
          <ValueAxis showZero={true} />

          <Legend
            visible={true}
            rowCount={1}
            verticalAlignment="bottom"
            horizontalAlignment="center"/>
          {false && <Tooltip
            enabled={true}
            customizeTooltip={customizeTooltip}
          />}
        </Chart>
        <Chart
          id="chart"
          dataSource={obsSafetyData}
          title='Does your company have a safety observation tracking program?'
          rotated={true}
        >
          <ArgumentAxis aggregatedPointsPosition="crossTicks">
            <AggregationInterval years={1} />
            <TickInterval years={1} />
          </ArgumentAxis>
          <CommonSeriesSettings
            argumentField="date"
          >
          </CommonSeriesSettings>
          <Series
            type="stackedbar"
            valueField="ycnt"
            name="Yes"
            color="rgba(20, 77, 109, 0.8)"
          >
          </Series>
          <Series
            type="stackedbar"
            valueField="ncnt"
            name="No"
            color="rgba(236, 80, 32, 0.8)"
          >
          </Series>
          <Series
            type="stackedbar"
            valueField="nrcnt"
            name="NR"
            color="rgba(0, 0, 0, 0.1)"
          >
          </Series>
          <ValueAxis showZero={true} />
          <Legend
            visible={true}
            rowCount={1}
            verticalAlignment="bottom"
            horizontalAlignment="center"/>
          {false && <Tooltip
            enabled={true}
            customizeTooltip={customizeTooltip}
          />}
        </Chart>
      </div>
      <div className="d-flex flex-column justify-content-between" style={{width:"50%"}}>
        <PieChart
          id="pie"
          type="doughnut"
          title={"Man-hour collection method (Employee) - "+props.year}
          palette={palette}
          dataSource={collectionDataEmpl}
          resolveLabelOverlapping={"shift"}
        >
          <PCSeries argumentField="name">
            <Label visible={true}>
              <Connector visible={true} />
            </Label>
          </PCSeries>
          <PCLegend rowCount={2} margin={0} horizontalAlignment="center" verticalAlignment="bottom" />
          <PCTooltip enabled={true} customizeTooltip={customizeTooltip}>
          </PCTooltip>
        </PieChart>
        <PieChart
          id="pie"
          type="doughnut"
          title={"Man-hour collection method (Contractor) - "+props.year}
          palette={palette}
          dataSource={collectionDataCont}
          resolveLabelOverlapping={"shift"}
        >
          <PCSeries argumentField="name">
            <Label visible={true}>
              <Connector visible={true} />
            </Label>
          </PCSeries>
          <PCLegend rowCount={2} margin={0} horizontalAlignment="center" verticalAlignment="bottom" />
          <PCTooltip enabled={true} customizeTooltip={customizeTooltip}>
          </PCTooltip>
        </PieChart>
      </div>
    </div>
    </>
  );
}
